export var IconSymbol;
(function (IconSymbol) {
    IconSymbol[IconSymbol["Add"] = 0] = "Add";
    IconSymbol[IconSymbol["Adsr"] = 1] = "Adsr";
    IconSymbol[IconSymbol["ArrayDown"] = 2] = "ArrayDown";
    IconSymbol[IconSymbol["AudioBus"] = 3] = "AudioBus";
    IconSymbol[IconSymbol["AudioDevice"] = 4] = "AudioDevice";
    IconSymbol[IconSymbol["AudioFile"] = 5] = "AudioFile";
    IconSymbol[IconSymbol["AutoGain"] = 6] = "AutoGain";
    IconSymbol[IconSymbol["Automation"] = 7] = "Automation";
    IconSymbol[IconSymbol["BassGuitar"] = 8] = "BassGuitar";
    IconSymbol[IconSymbol["Book"] = 9] = "Book";
    IconSymbol[IconSymbol["Box"] = 10] = "Box";
    IconSymbol[IconSymbol["Bug"] = 11] = "Bug";
    IconSymbol[IconSymbol["Fold"] = 12] = "Fold";
    IconSymbol[IconSymbol["Checkbox"] = 13] = "Checkbox";
    IconSymbol[IconSymbol["Clips"] = 14] = "Clips";
    IconSymbol[IconSymbol["Close"] = 15] = "Close";
    IconSymbol[IconSymbol["CloudFolder"] = 16] = "CloudFolder";
    IconSymbol[IconSymbol["CollapseDown"] = 17] = "CollapseDown";
    IconSymbol[IconSymbol["Compressor"] = 18] = "Compressor";
    IconSymbol[IconSymbol["Connected"] = 19] = "Connected";
    IconSymbol[IconSymbol["Cube"] = 20] = "Cube";
    IconSymbol[IconSymbol["Cursor"] = 21] = "Cursor";
    IconSymbol[IconSymbol["Curve"] = 22] = "Curve";
    IconSymbol[IconSymbol["Delete"] = 23] = "Delete";
    IconSymbol[IconSymbol["Dial"] = 24] = "Dial";
    IconSymbol[IconSymbol["DinSlot"] = 25] = "DinSlot";
    IconSymbol[IconSymbol["Disconnected"] = 26] = "Disconnected";
    IconSymbol[IconSymbol["Divide"] = 27] = "Divide";
    IconSymbol[IconSymbol["DragConnections"] = 28] = "DragConnections";
    IconSymbol[IconSymbol["Dropdown"] = 29] = "Dropdown";
    IconSymbol[IconSymbol["Dropbox"] = 30] = "Dropbox";
    IconSymbol[IconSymbol["DrumSet"] = 31] = "DrumSet";
    IconSymbol[IconSymbol["Duration"] = 32] = "Duration";
    IconSymbol[IconSymbol["EditBox"] = 33] = "EditBox";
    IconSymbol[IconSymbol["Effects"] = 34] = "Effects";
    IconSymbol[IconSymbol["Embed"] = 35] = "Embed";
    IconSymbol[IconSymbol["EQ"] = 36] = "EQ";
    IconSymbol[IconSymbol["Eraser"] = 37] = "Eraser";
    IconSymbol[IconSymbol["Exclude"] = 38] = "Exclude";
    IconSymbol[IconSymbol["Exit"] = 39] = "Exit";
    IconSymbol[IconSymbol["ExpandWidth"] = 40] = "ExpandWidth";
    IconSymbol[IconSymbol["FileList"] = 41] = "FileList";
    IconSymbol[IconSymbol["Flask"] = 42] = "Flask";
    IconSymbol[IconSymbol["Focus"] = 43] = "Focus";
    IconSymbol[IconSymbol["Generator"] = 44] = "Generator";
    IconSymbol[IconSymbol["GoogleDrive"] = 45] = "GoogleDrive";
    IconSymbol[IconSymbol["Groove"] = 46] = "Groove";
    IconSymbol[IconSymbol["Guitar"] = 47] = "Guitar";
    IconSymbol[IconSymbol["GuitarTab"] = 48] = "GuitarTab";
    IconSymbol[IconSymbol["Headphone"] = 49] = "Headphone";
    IconSymbol[IconSymbol["Heart"] = 50] = "Heart";
    IconSymbol[IconSymbol["Help"] = 51] = "Help";
    IconSymbol[IconSymbol["HighPass"] = 52] = "HighPass";
    IconSymbol[IconSymbol["HighShelf"] = 53] = "HighShelf";
    IconSymbol[IconSymbol["Insert"] = 54] = "Insert";
    IconSymbol[IconSymbol["Invert"] = 55] = "Invert";
    IconSymbol[IconSymbol["Loop"] = 56] = "Loop";
    IconSymbol[IconSymbol["LowPass"] = 57] = "LowPass";
    IconSymbol[IconSymbol["LowShelf"] = 58] = "LowShelf";
    IconSymbol[IconSymbol["Magnet"] = 59] = "Magnet";
    IconSymbol[IconSymbol["MainMenu"] = 60] = "MainMenu";
    IconSymbol[IconSymbol["Maximized"] = 61] = "Maximized";
    IconSymbol[IconSymbol["Menu"] = 62] = "Menu";
    IconSymbol[IconSymbol["Merge"] = 63] = "Merge";
    IconSymbol[IconSymbol["Metronome"] = 64] = "Metronome";
    IconSymbol[IconSymbol["Microphone"] = 65] = "Microphone";
    IconSymbol[IconSymbol["Midi"] = 66] = "Midi";
    IconSymbol[IconSymbol["Minimized"] = 67] = "Minimized";
    IconSymbol[IconSymbol["Mix"] = 68] = "Mix";
    IconSymbol[IconSymbol["Mixing"] = 69] = "Mixing";
    IconSymbol[IconSymbol["Mute"] = 70] = "Mute";
    IconSymbol[IconSymbol["NanoWave"] = 71] = "NanoWave";
    IconSymbol[IconSymbol["New"] = 72] = "New";
    IconSymbol[IconSymbol["NoAudio"] = 73] = "NoAudio";
    IconSymbol[IconSymbol["Note"] = 74] = "Note";
    IconSymbol[IconSymbol["NotePad"] = 75] = "NotePad";
    IconSymbol[IconSymbol["OpenDAW"] = 76] = "OpenDAW";
    IconSymbol[IconSymbol["Panel"] = 77] = "Panel";
    IconSymbol[IconSymbol["Peak"] = 78] = "Peak";
    IconSymbol[IconSymbol["Pencil"] = 79] = "Pencil";
    IconSymbol[IconSymbol["Piano"] = 80] = "Piano";
    IconSymbol[IconSymbol["Playfield"] = 81] = "Playfield";
    IconSymbol[IconSymbol["Play"] = 82] = "Play";
    IconSymbol[IconSymbol["Pointer"] = 83] = "Pointer";
    IconSymbol[IconSymbol["Popout"] = 84] = "Popout";
    IconSymbol[IconSymbol["Primary"] = 85] = "Primary";
    IconSymbol[IconSymbol["Random"] = 86] = "Random";
    IconSymbol[IconSymbol["Record"] = 87] = "Record";
    IconSymbol[IconSymbol["Rectangle"] = 88] = "Rectangle";
    IconSymbol[IconSymbol["Region"] = 89] = "Region";
    IconSymbol[IconSymbol["Robot"] = 90] = "Robot";
    IconSymbol[IconSymbol["RoundDown"] = 91] = "RoundDown";
    IconSymbol[IconSymbol["RoundUp"] = 92] = "RoundUp";
    IconSymbol[IconSymbol["Run"] = 93] = "Run";
    IconSymbol[IconSymbol["Saxophone"] = 94] = "Saxophone";
    IconSymbol[IconSymbol["Scissors"] = 95] = "Scissors";
    IconSymbol[IconSymbol["Search"] = 96] = "Search";
    IconSymbol[IconSymbol["Solo"] = 97] = "Solo";
    IconSymbol[IconSymbol["SoundFont"] = 98] = "SoundFont";
    IconSymbol[IconSymbol["SpeakerHeadphone"] = 99] = "SpeakerHeadphone";
    IconSymbol[IconSymbol["Stack"] = 100] = "Stack";
    IconSymbol[IconSymbol["Start"] = 101] = "Start";
    IconSymbol[IconSymbol["Stereo"] = 102] = "Stereo";
    IconSymbol[IconSymbol["Stop"] = 103] = "Stop";
    IconSymbol[IconSymbol["Subtract"] = 104] = "Subtract";
    IconSymbol[IconSymbol["Sun"] = 105] = "Sun";
    IconSymbol[IconSymbol["Swap"] = 106] = "Swap";
    IconSymbol[IconSymbol["System"] = 107] = "System";
    IconSymbol[IconSymbol["Table"] = 108] = "Table";
    IconSymbol[IconSymbol["Tape"] = 109] = "Tape";
    IconSymbol[IconSymbol["Time"] = 110] = "Time";
    IconSymbol[IconSymbol["Timeline"] = 111] = "Timeline";
    IconSymbol[IconSymbol["Tool"] = 112] = "Tool";
    IconSymbol[IconSymbol["Unknown"] = 113] = "Unknown";
    IconSymbol[IconSymbol["UserFolder"] = 114] = "UserFolder";
    IconSymbol[IconSymbol["Velocity"] = 115] = "Velocity";
    IconSymbol[IconSymbol["Vinyl"] = 116] = "Vinyl";
    IconSymbol[IconSymbol["VUMeter"] = 117] = "VUMeter";
    IconSymbol[IconSymbol["Waveform"] = 118] = "Waveform";
    IconSymbol[IconSymbol["Zeitgeist"] = 119] = "Zeitgeist";
})(IconSymbol || (IconSymbol = {}));
(function (IconSymbol) {
    IconSymbol.toName = (symbol) => IconSymbol[symbol];
    IconSymbol.fromName = (name) => IconSymbol[name] ?? IconSymbol.Rectangle;
})(IconSymbol || (IconSymbol = {}));
